module.exports = "<!-- router -->\n<router-outlet></router-outlet>\n\n<!-- preloader -->\n<app-preloader></app-preloader> "